import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { UriConfig } from '@app/app.config';
import { BrandItemDetailsModel } from '@app/common/models/VendorItemDetailsModel';
import { TenantsEnum } from '@enums/TenantsEnum';
import { UserDetailsModel } from '@models/UserDetailsModel';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  protected http = inject(HttpClient);
  private uriConfig = inject(UriConfig);

  currentUser$ = new BehaviorSubject<UserDetailsModel>(null);

  fetchUserInfo(): Observable<UserDetailsModel> {
    return this.http.get<UserDetailsModel>(this.uriConfig.user);
  }

  fetchAdminInfo(): Observable<UserDetailsModel> {
    return this.http.get<UserDetailsModel>(this.uriConfig.admins);
  }

  updateVendorUser(body: { brand: BrandItemDetailsModel; showUpsell: boolean }): Observable<UserDetailsModel> {
    return this.http.patch<UserDetailsModel>(this.uriConfig.user, body);
  }

  sendSwipeOnboardingNotification(body: { showNotification: boolean }): Observable<null> {
    return this.http.patch<null>(this.uriConfig.user + '/b2c/send-swiping-onboarding-notification', body);
  }

  sendStreakUsersOnboardingNotification(): Observable<null> {
    return this.http.patch<null>(this.uriConfig.user + '/b2c/update-streak-onboarding-flag', {});
  }

  sendConnect3UsersOnboardingNotification(): Observable<null> {
    return this.http.patch<null>(`${this.uriConfig.user}/b2c/update-connect3-info-tab-flag`, {});
  }

  isStreak(): boolean {
    return this.currentUserSnapshot.tenantType === TenantsEnum.STREAK;
  }

  isConnect3(): boolean {
    return this.currentUserSnapshot.tenantType === TenantsEnum.CONNECT3;
  }

  isPrediction(): boolean {
    return this.currentUserSnapshot.tenantType === TenantsEnum.PREDICTION;
  }

  isSuperSocial(): boolean {
    return this.currentUserSnapshot.tenantType === TenantsEnum.SUPERSOCIAL;
  }

  isPassTheBall(): boolean {
    return this.currentUserSnapshot.tenantType === TenantsEnum.PASS_THE_BALL;
  }

  get currentUserSnapshot(): UserDetailsModel {
    return this.currentUser$.value;
  }
}
